import { has } from "lodash-es";
export const dbReadonlyFields = Object.freeze(['_id', '_ctime', '_mtime', '_owner']);
export function deleteDbReadonlyFields(obj) {
  dbReadonlyFields.forEach(key => {
    if (has(obj, key)) {
      delete obj[key];
    }
  });
}
//# sourceMappingURL=dbReadonlyFields.js.map
